import React, { Component } from "react";
import { WebFormFieldProps } from "./index";
import { readValue, writeValue } from "@eres/forms/Utils";
import { DefaultProps } from "@eres/forms";

interface Props extends WebFormFieldProps<boolean, number> {
	yesLabel: string;
	noLabel: string;
	buttonContainerClassName?: string;
	buttonClass?: string;
	yesButtonClass?: string;
	noButtonClass?: string;
	activeButtonClass?: string;
}

class YesNoField extends Component<Props> {
	static defaultProps: DefaultProps<Props> = {
		containerClassName: "custom-control custom-yesno mt-3 mb-3",
		errorClassName: "invalid-feedback invalid-feedback-x",
		buttonContainerClassName: "btn-group btn-toggle btn-custom-toggle",
		buttonClass: "btn btn-default",
		activeButtonClass: "active",
	};

	onChange = ( v: boolean ) => {
		let value = v;
		if ( this.props.onValueChange ) {
			this.props.onValueChange( value );
		}
		writeValue( this.props, value );
	};

	render() {
		const {
			id, containerClassName, labelClassName, label, required, error, errorClassName,
			buttonContainerClassName, buttonClass, yesButtonClass, noButtonClass, activeButtonClass,
			yesLabel, noLabel
		} = this.props;
		const v = readValue( this.props );
		return (
			<React.Fragment>
				<div className={ containerClassName }>
					<label className={ labelClassName } htmlFor={ id }><span>{ label }</span>
						{ required && <span className="asterisk">*</span> }
					</label>
					<div>
						<div className={ buttonContainerClassName }>
							<button
								type="button"
								onClick={ this.setTrue }
								className={ [ buttonClass, yesButtonClass, v === true ? activeButtonClass : "" ].join( " " ) }>{ yesLabel }</button>
							<button
								type="button"
								onClick={ this.setFalse }
								className={ [ buttonClass, noButtonClass, v === false ? activeButtonClass : "" ].join( " " ) }>{ noLabel }</button>
						</div>
					</div>
					{ error && <div className={ errorClassName }>{ error }</div> }
				</div>

			</React.Fragment>
		);
	}

	private setTrue = () => {
		this.onChange( true );
	};

	private setFalse = () => {
		this.onChange( false );
	};
}

export default YesNoField;
